import { useTheme } from '@hooks/useTheme';
import { FC, HTMLProps, memo } from 'react';
import { Icon } from '../Icon';
import { visuallyHiddenStyle } from '../VisuallyHidden';

// ts-unused-exports:disable-next-line
export interface Props extends Omit<HTMLProps<HTMLInputElement>, 'value'> {
  size?: number;
  value?: string | boolean;
  useDefaultStylesWhenDisabled?: boolean;
  disableClickBubble?: boolean;
  labelProps?: HTMLProps<HTMLLabelElement>;
}

export const DEFAULT_CHECKBOX_SIZE = 28;

export const Checkbox: FC<Props> = memo(
  ({
    size = DEFAULT_CHECKBOX_SIZE,
    useDefaultStylesWhenDisabled,
    labelProps,
    disableClickBubble,
    ...props
  }) => {
    const { gray, colors, formElement } = useTheme();
    const { checked, disabled } = props;

    const useDisabledStyles = disabled && !useDefaultStylesWhenDisabled;

    return (
      <label
        css={{
          position: 'relative',
          cursor: useDisabledStyles ? 'default' : 'pointer',
          padding: 0,
          height: size,
          width: size,
          '&:active': { background: gray[200] },
        }}
        className="checkbox"
        onClick={
          disableClickBubble ? (e): void => e.stopPropagation() : undefined
        }
        {...labelProps}
      >
        <input
          {...(props as anyOk)}
          type="checkbox"
          css={{
            ...visuallyHiddenStyle,
            '&:focus ~ span': {
              ...formElement.focused,
            },
          }}
        />
        <span
          css={{
            position: 'absolute',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            height: '100%',
            background: useDisabledStyles
              ? gray[100]
              : checked
              ? colors.primary
              : 'white',
          }}
          data-testid="checkboxSpan"
          className="input"
        >
          <Icon
            i="check"
            size={size / 2}
            css={{
              display: checked ? 'block' : 'none',
            }}
            color={
              checked ? (useDisabledStyles ? gray[700] : 'white') : 'inherit'
            }
          />
        </span>
      </label>
    );
  }
);
